import { COLORS } from '@elo-kit/constants/general.constants'
import { getFontStyles } from '@elo-kit/utils/fonts.utils'
import { cleanupFonts } from 'utils/fonts.utils'

const { eloBlue } = COLORS

// TODO: update with using createUseStyles
const pageNavigationStyles = (theme) => {
  const breadCrumbLinkFont = cleanupFonts(theme.breadCrumbLinkFont) || 'Montserrat Reg'
  return {
    pageNavigation: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      fontSize: 13,
      paddingTop: 10,
      paddingBottom: 30,
      fontFamily: cleanupFonts(theme.lesson.bannerFont) || 'Montserrat Reg',
      color: '#9e9e9e',
    },

    pageNavigationBreadCrumb: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      alignItems: 'center',
      fontSize: 13,
      paddingTop: 10,
      paddingBottom: 30,
      color: '#9e9e9e',
      visibility: theme.showBreadcrumb === false ? 'hidden' : 'visible',
      '@media (max-width: 991px)': {
        marginTop: `${theme.headerHidden ? '0' : '60px'} !important`,
      },
      '& i': {
        padding: '0 20px',
        color: theme.breadCrumbLinkColor || eloBlue,
        fontSize: `${theme.breadCrumbLinkSize || '13'}px`,

        '@media (max-width: 576px)': {
          fontSize: theme.breadCrumbLinkSize > 16 ? 16 : 13,
        },
      },
      '& a': {
        color: theme.breadCrumbLinkColor || eloBlue,
        ...getFontStyles(theme.breadCrumbLinkStyle || 'normal'),
        fontFamily: breadCrumbLinkFont,
        fontSize: `${theme.breadCrumbLinkSize || '13'}px`,

        '@media (max-width: 576px)': {
          fontSize: theme.breadCrumbLinkSize > 16 ? 16 : 13,
        },
      },
    },

    pageNavigationCurrentItem: {
      color: theme.activeLinkColor || '#9e9e9e',
      ...getFontStyles(theme.breadCrumbLinkStyle || 'normal'),
      fontFamily: breadCrumbLinkFont,
      fontSize: `${theme.breadCrumbLinkSize || '13'}px`,

      '@media (max-width: 576px)': {
        fontSize: theme.breadCrumbLinkSize > 16 ? 16 : 13,
      },
    },

    pageNavigationActiveItem: {
      color: theme.linkColor || eloBlue,
      ...getFontStyles(theme.breadCrumbLinkStyle || 'normal'),
      fontFamily: breadCrumbLinkFont,
      fontSize: `${theme.breadCrumbLinkSize || '13'}px`,
      cursor: 'pointer',

      '&:hover': {
        opacity: 0.8,
      },

      '@media (max-width: 576px)': {
        fontSize: theme.breadCrumbLinkSize > 16 ? 16 : 13,
      },
    },

    navigationBlock: {
      margin: '0 auto',
      position: 'relative',
      paddingLeft: 10,
      maxWidth: 1140,
    },

    withResetNavigation: {
      margin: 0,
      paddingRight: 10,
      '@media (max-width: 991px)': {
        marginTop: `${theme.headerHidden ? '0' : '50px'} !important`,
      },
    },
  }
}

export default pageNavigationStyles
